import React, { useEffect, useState } from "react";
import Table from "./Table";

import { gql, useLazyQuery } from "@apollo/client";
import { Spin } from "antd";

import { CSVLink } from "react-csv";
import FileUpload from "../Events/components/FileUpload/FileUpload";
import UpdateUser from "./Users/UpdateUser";


import moment from "moment";
import { Redirect, useHistory } from "react-router-dom";

export interface Condition {
  _id: string;
  name: string;
}

export interface IPhysicians {
  physiciansOverview: {
    _id: string;
    name: string;
    NPI: string;
    contact: string;
    email: string;
    role: string;
    alertMethod: string;
    active: number;
    conditions: Condition[];
  }[];
}

interface iToken {
  login_as: {
    token: string;
  };
}

const DATA_PHYSICIANS = gql`
  query ($physiciansName: String!, $NPI: String!, $Condition: String!, $sortInput: PhysiciansSort!) {
    physiciansOverview(
      physiciansName: $physiciansName
      NPI: $NPI
      Condition: $Condition
      sort: $sortInput
    ) {
      _id
      name
      contact
      email
      NPI
      role
      alertMethod
      active
      conditions{
        name
      }
    }
  }
`;

const GET_TOKEN = gql`
  query ($email: String!) {
    login_as(email: $email) {
      token
    }
  }
`;

export default function Physicians() {
  const [displayData, setDisplayData] = useState<any>([]);
  const [physiciansName, setPhysiciansName] = useState("");
  const [NPI, setNPI] = useState("");
  const [Condition, setCondition] = useState("");
  const [sortInput, setSortInput] = useState<object>({_id: -1})

  const { push } = useHistory();

  const [getPhysicians, { loading, error, data }] = useLazyQuery<IPhysicians>(
    DATA_PHYSICIANS,
    {
      fetchPolicy: "network-only",
      onCompleted: (completeData) => {
        const tempArr = [];
        tempArr.push([
          "User ID",
          "User name",
          "NPI",
          "Cell phone",
          "Email",
          "Role",
          "AlertMethod",
          "Active",
          "Conditions"
        ]);

        completeData.physiciansOverview.forEach((value: any) => {
          tempArr.push([
            value._id,
            value.name,
            value.NPI,
            value.contact,
            value.email,
            value.role,
            value.alertMethod,
            value.active,
            value.conditions.map((condition: Condition) => `${condition.name}`).join(' ')
          ]);
        });
        console.log(completeData.physiciansOverview);

        setDisplayData(tempArr);
      },
    }
  );

  const [getToken] = useLazyQuery<iToken>(GET_TOKEN, {
    fetchPolicy: "network-only",
    onCompleted: (completeData) => {
      //console.log("complete token", completeData);
      localStorage.setItem("zilius-token", completeData.login_as.token);
      window.location.reload();
    },
  });

  useEffect(() => {
    getDefaultData();
  }, []);

  const getDefaultData = () => {
    getPhysicians({
      variables: {
        physiciansName: "",
        NPI: "",
        Condition:"",
        sortInput: {_id: -1}
      },
    });
  };

  const getData = () => {
    getPhysicians({
      variables: {
        physiciansName: physiciansName,
        NPI: NPI,
        Condition: Condition,
        sortInput: sortInput
      },
    });
  };

  const clearForm = () => {
    setPhysiciansName("");
    setNPI("");
    setCondition("");
    setSortInput({_id: -1})
    getDefaultData();
  };

  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      getData();
    }
  };

  const buttonClickHandler = (tableRow: any) => {
    //console.log("email", tableRow[4]);
    getToken({
      variables: {
        email: tableRow[4],
      },
    });
  };

  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");
  const handleSorting = (index: any) => {
    const sortOrder =
    index === sortField && order === "asc" ? "desc" : "asc";
    const sortHeader = ["_id","name","NPI","contact","email","role","alertMethod","active"][index]
    const int_sort = (sortOrder === "asc" ? 1 : -1)
    const sortInput = {[sortHeader]: int_sort}
    setSortField(index);
    setOrder(sortOrder);
    getPhysicians({
      variables: {
        physiciansName: physiciansName,
        NPI: NPI,
        Condition: Condition,
        sortInput: sortInput
      },
    });
   };

  return (
    <>
      {loading || data === undefined ? (
        <>
          <Spin />
        </>
      ) : (
        <>
          <div className="exportuploadbuttonposition">
            <FileUpload />
            <CSVLink
              data={displayData}
              filename={`Users_${moment().format(
                "MM/DD/YYYY_HH:mm:ss"
              )}.csv`}
              className="export-button"
            >
              Export
            </CSVLink>
            {/* <button
              className="export-button"
              onClick={() => {

                push("user/create");
                }}
              >
                Create
            </button> */}
          </div>
          <div className="flex-between search-filter-box">
            <div className="flex">
              <div>
                <span className="search-filter-label">
                  Search by user name
                </span>
                <input
                  type="text"
                  className="search-filter-input"
                  value={physiciansName}
                  onChange={(e) => setPhysiciansName(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
              </div>
              <div>
                <span className="search-filter-label">Search by NPI</span>
                <input
                  type="text"
                  className="search-filter-input"
                  value={NPI}
                  onChange={(e) => setNPI(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
              </div>
              <div>
                <span className="search-filter-label">Search by condition</span>
                <input
                  type="text"
                  className="search-filter-input"
                  value={Condition}
                  onChange={(e) => setCondition(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
              </div>
            </div>

            <div className="searchButtons">
              <button
                className="export-button clear"
                onClick={() => {
                  clearForm();
                }}
              >
                Clear
              </button>
              <button
                className="export-button"
                onClick={() => {
                  getData();
                }}
              >
                Search
              </button>
            </div>
          </div>
          <Table
            headers={[
              "User ID",
              "User name",
              "NPI",
              "Cell phone",
              "Email",
              "Role",
              "Alert Method",
              "Active",
              "Conditions"
            ]}
            headersSortBool={[
              true,
              true,
              true,
              true,
              true,
              true,
              true,
              true,
              false
            ]}
            data={data?.physiciansOverview.map((value) => [
              value._id,
              value.name,
              value.NPI,
              value.contact,
              value.email,
              value.role,
              value.alertMethod,
              value.active==1?"Yes":"No",
              value.conditions.map((condition: Condition) => `${condition.name}`).join(' ')
            ])}
            buttonClick={buttonClickHandler}
            handleSorting={handleSorting}
            order={order}
            field={sortField}
          />
        </>
      )}
    </>
  );
}
